import React, { useState } from "react";
import "../MobileHeader/MobileHeader.css";
import "./MobileNavBar.css";
import logo from "../../../assets/images/logo1.jpg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid, regular, brands, icon } from "@fortawesome/fontawesome-svg-core/import.macro";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { slice1Actions } from "../../../store/reducer";
import Common, { Settings, SortByEnum, AUTHORIZATION_LEVEL, COLORS } from "../../../Common/Common";
//import ReactGA from "react-ga";
import ReactGA from "react-ga4";
import DestinationsScreen from "../../modals/DestinationsScreen";

const MobileNavBar = () => {
  const dispatch = useDispatch();
  const [showDestinations, setShowDestinations] = useState(false);
  let CurrentAppScreen = useSelector((state) => state.CurrentAppScreen);
  let creator_info = useSelector((state) => state.creator_info);
  let owner_info = useSelector((state) => state.owner_info);
  let user_info = useSelector((state) => state.user_info);
  let AppSettings = useSelector((state) => state.AppSettings);
  let MobileMode = useSelector((state) => state.MobileMode);
  let NoAds = useSelector((state) => state.NoAds);
  let GuideSettings = useSelector((state) => state.GuideSettings);
  let GuideFormat = useSelector((state) => state.GuideFormat);
  let HTMLStack = useSelector((state) => state.HTMLStack);
  let AppScreenStack = useSelector((state) => state.AppScreenStack);
  let GuidesOrPlaces = useSelector((state) => state.GuidesOrPlaces);

  const NavigateToScreen = (screen) => {
    console.log("NavigateToScreen", screen, CurrentAppScreen);
    // A direct tab tap is a fresh navigation, not a "return from a menu
    // jump" — clear AppScreenStack so PlacesHeader.js's/ScheduleHeader.js's
    // back arrows (shown when it's non-empty) don't linger and point
    // somewhere stale the next time this screen is reached this way.
    // Found/fixed 2026-09-09.
    dispatch(slice1Actions.clearAppScreenStack());
    if (GuidesOrPlaces !== "Places") {
      dispatch(slice1Actions.setGuidesOrPlaces({ value: "Places", GuideType: "None" }));
    }
    //  if(screen === "Home" && GuideFormat === "Photo Mosaic"){
    //     const htmlp = window.guide_obj.createHTMLItinerary("Main", GuideSettings.itinerary);
    //         window.guide_obj.document = htmlp;
    //         dispatch(slice1Actions.clearHTMLStack());
    //         //dispatch(slice1Actions.popHTMLStack());
    //         dispatch(slice1Actions.setHomeScreen({ value: htmlp }));
    //  }
    // else 
    if (screen === "Home" && CurrentAppScreen === "Home") 
      {
          // dispatch(slice1Actions.resetHomeScreen({ value: null }));
          // dispatch(slice1Actions.setScheduleName({ value: "Main" }));
          // dispatch(slice1Actions.setCurrentAppScreen({ value: "Home" }));
          // setTimeout(() => delayedHomeUpdate(), 500);
          let html = window.guide_obj.document;
          if(GuideFormat === "Photo Mosaic")
            html = window.guide_obj.createHTMLItinerary("Main", GuideSettings.itinerary);
          dispatch(slice1Actions.setHTMLTitle({ value: "Itinerary" }));
          dispatch(slice1Actions.clearHTMLStack());
          dispatch(slice1Actions.setHTMLToSHow({ value: html }));
          dispatch(slice1Actions.setShowHTMLReader({ value: true }));
          window.location.href = "#home-start";
          var homeDiv = document.getElementById("home-content-start");
          if (MobileMode) dispatch(slice1Actions.setCurrentAppScreen({ value: "Home" }));
          else homeDiv.scrollIntoView();
      }
      
      else 
        dispatch(slice1Actions.setCurrentAppScreen({ value: screen }));
    // ReactGA.event({
    //   category: "navigation",
    //   action: "mobile-footer-navigate",
    //   label: screen,
    // });
  };

  // const delayedHomeUpdate = () => {
  //   dispatch(slice1Actions.setScheduleName({ value: "Main" }));
  //   dispatch(slice1Actions.setCurrentAppScreen({ value: "Home" }));
  //   const html = window.guide_obj.createHTMLItinerary("Main", GuideSettings.itinerary);
  //   window.guide_obj.document = html
  //   setTimeout(() => delayedHomeUpdate2(), 500);
  // };

  // const delayedHomeUpdate2 = () => {
  //   const html = window.guide_obj.createHTMLItinerary("Main", GuideSettings.itinerary);
  //   window.guide_obj.document = html
  //   dispatch(slice1Actions.setScheduleName({ value: "Main" }));
  //   dispatch(slice1Actions.setCurrentAppScreen({ value: "Home" }));
  // };


  const userColor = (screen) => {
    return CurrentAppScreen === screen ? "#fdcb6e" : "#3598DB";
  };

  const goBack = () => {
    if (GuidesOrPlaces !== "Places") {
      dispatch(slice1Actions.setGuidesOrPlaces({ value: "Places", GuideType: "None" }));
      return;
    }
    if (HTMLStack.length <= 1) {
      dispatch(slice1Actions.clearHTMLStack());
      return;
    }
    const htmlString = HTMLStack[HTMLStack.length - 2];
    dispatch(slice1Actions.popHTMLStack());
    dispatch(slice1Actions.setHomeScreen({ value: htmlString }));
  };

  const purchaseTickets = () => {
    // Loaded from a fixed URL now, not AppSettings.tickets — opened directly
    // rather than fetched-and-injected, since fetching a different origin's
    // HTML would hit CORS unless andiamoplaces.com explicitly allows it.
    window.open("https://andiamoplaces.com/Docs/Tickets.html", "_blank");
  };

  const tabs = [
    { screen: "Home",     icon: solid("file-lines"),    label: "Itinerary" },
    { screen: "Places",   icon: solid("location-dot"),  label: "Places"    },
    { screen: "Map",      icon: solid("map"),            label: "Map"       },
    { screen: "Schedule", icon: solid("calendar"),       label: "Schedule"  },
  ];

  const openPrivacy = () => {
    window.open("/Docs/privacy-policy.html", "_blank");
  };

  // Suppressed on Map/Places/Schedule while that screen's own back arrow
  // is showing (PlacesHeader.js for Map/Places, ScheduleHeader.js for
  // Schedule — both gated on AppScreenStack, pushed to by a menu/link
  // action like PlaceModal's "Center in Map" or Home.js's maplink/
  // schedulelink) — that arrow and this tab pop two different, unrelated
  // histories (screen-navigation vs. HTML content), and having both
  // visible at once read as confusing/redundant even though each worked
  // correctly on its own. Found/fixed 2026-09-09, generalized to
  // Places/Schedule and to a real stack the same day.
  const isSubPage = HTMLStack.length > 1 && !(AppScreenStack.length > 0 && ["Map", "Places", "Schedule"].includes(CurrentAppScreen));

  return (
    <div className="mnb-bar">
      <div className="mnb-track">
        {isSubPage && (
          <div className="mnb-tab mnb-back" onClick={goBack}>
            <span className="mnb-icon">
              <FontAwesomeIcon icon={solid("arrow-left")} />
            </span>
            <span className="mnb-label">Back</span>
          </div>
        )}
        {tabs.map(({ screen, icon, label }, i) => (
          <React.Fragment key={screen}>
            <div
              className={`mnb-tab${CurrentAppScreen === screen ? " mnb-active" : ""}`}
              onClick={() => NavigateToScreen(screen)}
            >
              <span className="mnb-icon">
                <FontAwesomeIcon icon={icon} />
              </span>
              <span className="mnb-label">{label}</span>
            </div>
            {i === 0 && (
              <div className="mnb-tab" onClick={() => setShowDestinations(true)}>
                <span className="mnb-icon">
                  <FontAwesomeIcon icon={solid("map-location-dot")} />
                </span>
                <span className="mnb-label">Destination</span>
              </div>
            )}
          </React.Fragment>
        ))}
      </div>
      {showDestinations && <DestinationsScreen onHide={() => setShowDestinations(false)} />}
    </div>
  );
};

export default MobileNavBar;
